(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[174],{

/***/ "ByKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "FooterContainer", function() { return /* binding */ FooterContainer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("6LKR");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: ./src/client/components/widgets/cookie-warning/constants.js
var constants = __webpack_require__("+LXU");

// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/PreferencesItemSwitch.jsx

var __jsx = react_default.a.createElement;




var PreferencesItemSwitch_PreferencesItemSwitch = function PreferencesItemSwitch(_ref) {
  var index = _ref.index,
      isChecked = _ref.isChecked,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      title = _ref.title;
  return __jsx("div", {
    className: "flex gap-15 mt-15"
  }, __jsx(InputSwitch["a" /* InputSwitch */], {
    ariaDescribedby: "".concat(name, "-text"),
    ariaLabelledby: name,
    color: colors["a" /* COLORS */].SAFFRON,
    isChecked: isChecked,
    isDisabled: index === 0,
    isSwitch: true,
    name: name,
    onChange: onChange(index),
    value: name
  }), __jsx("div", {
    className: "flex-1"
  }, __jsx("h4", {
    id: name,
    className: "font-bold font-sans leading-normal text-black text-12 sm:text-14 uppercase"
  }, title), __jsx(Text["a" /* Text */], {
    id: "".concat(name, "-text"),
    className: "font-sans leading-normal text-black text-12 sm:text-14",
    text: label
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookiePreferencesLayer.jsx



var CookiePreferencesLayer_jsx = react_default.a.createElement;












var CookiePreferencesLayer_CookiePreferencesLayer = function CookiePreferencesLayer(_ref) {
  var approveAriaLabel = _ref.approveAriaLabel,
      back = _ref.back,
      backAriaLabel = _ref.backAriaLabel,
      buttonLabel = _ref.buttonLabel,
      closeLabel = _ref.closeLabel,
      closeLayer = _ref.closeLayer,
      items = _ref.items,
      link = _ref.link,
      onChange = _ref.onChange,
      onValidatePreferences = _ref.onValidatePreferences,
      personnalCookiesState = _ref.personnalCookiesState,
      text = _ref.text,
      title = _ref.title;
  return CookiePreferencesLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: title,
    ariaLabelledby: identifiers_constants["q" /* ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES */],
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      ariaHidden: true,
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: backAriaLabel,
      onClick: closeLayer,
      tabIndex: -1
    },
    closeLabel: closeLabel,
    enterAnimation: "slideInBottom",
    hasAnimateEnter: true,
    hasContainer: true,
    hasContainerHeader: true,
    onClose: closeLayer
  }, CookiePreferencesLayer_jsx("div", {
    className: "py-20"
  }, CookiePreferencesLayer_jsx("div", {
    className: "text-center"
  }, CookiePreferencesLayer_jsx(Icon["a" /* Icon */], {
    className: "mb-20",
    color: colors["a" /* COLORS */].BLACK,
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED,
    width: "10rem"
  })), !!title && CookiePreferencesLayer_jsx("h3", {
    className: "font-bold font-sans leading-tight mb-5 text-black text-16 sm:text-18",
    id: identifiers_constants["q" /* ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES */]
  }, title), CookiePreferencesLayer_jsx(Text["a" /* Text */], {
    className: "font-sans leading-normal mb-5 text-black text-12 sm:text-14",
    text: text
  }), !!link.label && CookiePreferencesLayer_jsx("p", {
    className: "font-bold font-sans leading-normal mb-5 mt-0 text-black text-12 sm:text-14"
  }, CookiePreferencesLayer_jsx(DynamicLink["a" /* default */], {
    className: "no-underline text-black hocus:text-black-active",
    target: "_blank",
    url: link.url
  }, link.label)), Object.keys(items).map(function (key, i) {
    return CookiePreferencesLayer_jsx(PreferencesItemSwitch_PreferencesItemSwitch, {
      index: i,
      isChecked: i === 0 || personnalCookiesState[constants["a" /* COOKIES_ARRAY */][i - 1]],
      key: key,
      label: items[key].label,
      name: "CookiePreferences-".concat(key),
      onChange: onChange,
      title: items[key].title
    });
  }), CookiePreferencesLayer_jsx("div", {
    className: "flex flex-col sm:flex-row-reverse sm:items-center sm:justify-between mt-15"
  }, CookiePreferencesLayer_jsx(Button["a" /* Button */], {
    ariaLabel: approveAriaLabel,
    className: "sm:w-1/6",
    onClick: onValidatePreferences
  }, buttonLabel), CookiePreferencesLayer_jsx(TextLink["a" /* TextLink */], {
    "aria-hidden": "true",
    className: "block flex-row-reverse font-bold justify-center mt-10 sm:mt-0",
    color: colors["a" /* COLORS */].SIENNA,
    iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
    label: back,
    onClick: closeLayer,
    tabIndex: -1
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookieWarningBanner.jsx


var CookieWarningBanner_jsx = react_default.a.createElement;








var CookieWarningBanner_CookieWarningBanner = function CookieWarningBanner(_ref) {
  var acceptCookies = _ref.acceptCookies,
      approveAriaLabel = _ref.approveAriaLabel,
      buttonLabel = _ref.buttonLabel,
      cookieKey = _ref.cookieKey,
      dataSelector = _ref.dataSelector,
      link = _ref.link,
      openLayer = _ref.openLayer,
      openLayerLabel = _ref.openLayerLabel,
      text = _ref.text,
      title = _ref.title;
  return CookieWarningBanner_jsx(react["Fragment"], null, CookieWarningBanner_jsx("section", {
    className: "bg-white fixed bottom-0 shadow w-full z-6"
  }, CookieWarningBanner_jsx(SiteContainer["a" /* SiteContainer */], null, CookieWarningBanner_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-center py-10"
  }, CookieWarningBanner_jsx("div", {
    className: "p-10"
  }, !!title && CookieWarningBanner_jsx("h3", {
    className: "font-bold font-sans leading-tight mb-5 text-black text-16 sm:text-18"
  }, title), CookieWarningBanner_jsx(Text["a" /* Text */], {
    className: "font-sans leading-normal mb-5 text-black text-12 sm:text-14",
    text: text
  }), !!link.label && CookieWarningBanner_jsx("p", {
    className: "font-bold font-sans leading-normal mb-5 mt-0 text-black text-12 sm:text-14"
  }, CookieWarningBanner_jsx(DynamicLink["a" /* default */], {
    className: "no-underline text-black hocus:text-black-active",
    target: "_blank",
    url: link.url
  }, link.label))), CookieWarningBanner_jsx("div", {
    className: "shrink-0 p-10 text-center sm:w-1/5 sm:max-w-320"
  }, CookieWarningBanner_jsx(Button["a" /* Button */], {
    ariaLabel: approveAriaLabel,
    className: "w-full",
    onClick: acceptCookies
  }, buttonLabel), CookieWarningBanner_jsx(TextLink["a" /* TextLink */], {
    className: "font-bold mt-15",
    color: colors["a" /* COLORS */].SIENNA,
    label: openLayerLabel,
    onClick: openLayer
  }))))), CookieWarningBanner_jsx("script", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: "\n        var banner = document.querySelector(\"div[data-selector='".concat(dataSelector, "']\");\n\n        if (banner && document && document.cookie.match(/").concat(cookieKey, "=1/)) {\n          console.log('hide')\n          banner.style.display = \"none\";\n        }\n      ")
    }
  }));
};

/* harmony default export */ var cookie_warning_CookieWarningBanner = (CookieWarningBanner_CookieWarningBanner);
// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookieWarning.jsx





















var CookieWarning_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }













var CookieWarning_CookieWarning = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_CookieWarning, _Component);

  var _super = _createSuper(_CookieWarning);

  function _CookieWarning() {
    var _personnalCookies;

    var _this;

    Object(classCallCheck["a" /* default */])(this, _CookieWarning);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      hasApproved: false,
      personnalCookies: (_personnalCookies = {}, Object(defineProperty["a" /* default */])(_personnalCookies, constants["f" /* COOKIE_PREFERENCES_STATS */], true), Object(defineProperty["a" /* default */])(_personnalCookies, constants["e" /* COOKIE_PREFERENCES_PERSO */], true), Object(defineProperty["a" /* default */])(_personnalCookies, constants["d" /* COOKIE_PREFERENCES_MEDIA */], true), _personnalCookies),
      showBanner: true,
      showLayer: false
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "acceptCookies", function () {
      _this.updateCookies();

      _this.setState({
        showBanner: false,
        hasApproved: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwitchChange", function (index) {
      return function (name, checked) {
        var realIndex = index - 1;

        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            personnalCookies: _objectSpread(_objectSpread({}, prevState.personnalCookies), {}, Object(defineProperty["a" /* default */])({}, constants["a" /* COOKIES_ARRAY */][realIndex], checked))
          });
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onValidatePreferences", function () {
      _this.updateCookies();

      _this.setState({
        hasApproved: true
      }, _this.closeLayer);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirect", function (router, type) {
      var url = new URI_default.a(router.asPath)[type](Object(defineProperty["a" /* default */])({}, dist["appQueryParameters"].openLayer, constants["c" /* COOKIE_PREFERENCES_LAYER */])).toString();
      router.push(url, undefined, {
        shallow: true,
        scroll: false
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeLayer", function () {
      _this.redirect(_this.props.router, 'removeQuery');
    });

    return _this;
  }

  Object(createClass["a" /* default */])(_CookieWarning, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var previousPathname = new URI_default.a(prevProps.router.asPath).pathname();
      var pathname = new URI_default.a(this.props.router.asPath).pathname();

      if (previousPathname !== pathname && !this.state.hasApproved) {
        this.setState({
          showBanner: false,
          showLayer: false,
          hasApproved: true
        }, this.updateCookies);
      }
    }
  }, {
    key: "updateCookies",
    value: function updateCookies() {
      var _this2 = this;

      var cookieOptions = {
        expires: moment_default()().add(13, 'month').toDate()
      };
      var cookieValue;
      js_cookie_default.a.set(constants["g" /* COOKIE_WARNING_LOCALSTORAGE_KEY */], 1, cookieOptions);
      constants["a" /* COOKIES_ARRAY */].forEach(function (cookieName) {
        cookieValue = _this2.state.personnalCookies[cookieName];
        js_cookie_default.a.set(cookieName, +cookieValue, cookieOptions);
      }); // retrieve current virtualPageLoadingDataLayer

      var currentPageDataLayer = tracking_api["a" /* getDataLayer */]().google.find(function (layer) {
        return layer.event === tracking_constants["A" /* VIRTUAL_PAGE_LOAD */];
      }) || {};
      tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({}, currentPageDataLayer), {}, {
        rgpd: 'OK'
      }), this.context);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          approveAriaLabel = _this$props.approveAriaLabel,
          buttonLabel = _this$props.buttonLabel,
          closeLabel = _this$props.closeLabel,
          layerInfo = _this$props.layerInfo,
          link = _this$props.link,
          router = _this$props.router,
          text = _this$props.text,
          title = _this$props.title;

      var _ref = layerInfo || {},
          back = _ref.back,
          backAriaLabel = _ref.backAriaLabel,
          openLayerLabel = _ref.link,
          rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["back", "backAriaLabel", "link"]);

      if (this.state.showBanner && text) {
        return CookieWarning_jsx(cookie_warning_CookieWarningBanner, {
          acceptCookies: this.acceptCookies,
          approveAriaLabel: approveAriaLabel,
          buttonLabel: buttonLabel,
          cookieKey: constants["g" /* COOKIE_WARNING_LOCALSTORAGE_KEY */],
          dataSelector: "cookieWarning",
          link: link,
          openLayer: function openLayer() {
            return _this3.redirect(router, 'addQuery');
          },
          openLayerLabel: openLayerLabel,
          text: text,
          title: title
        });
      }

      if (this.state.showLayer) {
        return CookieWarning_jsx(CookiePreferencesLayer_CookiePreferencesLayer, {
          approveAriaLabel: approveAriaLabel,
          back: back,
          backAriaLabel: backAriaLabel,
          buttonLabel: buttonLabel,
          closeLabel: closeLabel,
          closeLayer: this.closeLayer,
          items: rest,
          link: link,
          onChange: this.onSwitchChange,
          onValidatePreferences: this.onValidatePreferences,
          personnalCookiesState: this.state.personnalCookies,
          text: text,
          title: title
        });
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // first time rendering check if cookies were already approved
      // TODO change this because it prevents the customization after having set the cookies
      if (props.isApproved) {
        return {
          showBanner: false,
          showLayer: false,
          hasApproved: true
        };
      } // check in the location if we have to open the cookie preferences layer


      if (props.isAppMounted && props.router.query[dist["appQueryParameters"].openLayer] === constants["c" /* COOKIE_PREFERENCES_LAYER */] && !state.showLayer) {
        return {
          showBanner: false,
          showLayer: true
        };
      }

      if ((props.router.query[dist["appQueryParameters"].openLayer] !== constants["c" /* COOKIE_PREFERENCES_LAYER */] || !props.router.query[dist["appQueryParameters"].openLayer]) && state.showLayer) {
        return {
          showBanner: !state.hasApproved,
          showLayer: false
        };
      }

      return null;
    }
  }]);

  return _CookieWarning;
}(react["Component"]); // $FlowFixMe

Object(defineProperty["a" /* default */])(CookieWarning_CookieWarning, "contextType", ReactAppContext["a" /* B2CAppContext */]);

Object(defineProperty["a" /* default */])(CookieWarning_CookieWarning, "defaultProps", {
  buttonLabel: '',
  isApproved: false,
  // $FlowFixMe
  layerInfo: {
    back: '',
    link: '',
    item1: {
      title: '',
      label: ''
    },
    item2: {
      title: '',
      label: ''
    },
    item3: {
      title: '',
      label: ''
    },
    item4: {
      title: '',
      label: ''
    }
  },
  link: {
    label: '',
    url: ''
  },
  text: '',
  title: ''
});

var CookieWarning = Object(next_router["withRouter"])(CookieWarning_CookieWarning);
// EXTERNAL MODULE: ./src/utils/analytics/analyticsUtils.js
var analyticsUtils = __webpack_require__("kdyR");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-annexes/FooterAnnexes.jsx

var FooterAnnexes_jsx = react_default.a.createElement;



var FooterAnnexes_FooterAnnexes = function FooterAnnexes(_ref) {
  var className = _ref.className,
      openDidomiPreferences = _ref.openDidomiPreferences,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return FooterAnnexes_jsx("div", {
    className: className
  }, FooterAnnexes_jsx("ul", {
    className: "mb-20 -mx-10"
  }, items.map(function (_ref2) {
    var label = _ref2.label,
        links = _ref2.links;
    return FooterAnnexes_jsx("li", {
      className: "align-top inline-block mb-20 px-10 w-1/3",
      "data-testid": "FooterAnnexesItem",
      key: label
    }, FooterAnnexes_jsx("p", {
      "aria-level": "2",
      className: "font-bold leading-1 mb-10 text-12 uppercase",
      "data-testid": "FooterAnnexesHeading",
      role: "heading"
    }, label), FooterAnnexes_jsx("ul", null, links.map(function (link, idx) {
      return FooterAnnexes_jsx(react["Fragment"], {
        key: link.href
      }, FooterAnnexes_jsx("li", {
        className: "leading-loose mb-5 text-12"
      }, FooterAnnexes_jsx("a", {
        className: "inline-block leading-1 text-inherit hocus:text-black-active transition-color",
        rel: "noopener noreferrer",
        target: "_blank",
        href: link.href
      }, link.label)), Object(localeUtils["b" /* isLocaleToDisplayDidomi */])() && idx === links.length - 1 && Object(i18n["h" /* t */])('footer.legalInformations.title') === label && FooterAnnexes_jsx("li", {
        className: "leading-loose mb-5 text-12",
        key: link.label
      }, FooterAnnexes_jsx("button", {
        className: "inline-block leading-1 text-inherit hocus:text-black-active transition-color",
        onClick: openDidomiPreferences,
        type: "button"
      }, Object(i18n["h" /* t */])('footer.legalInformations.cookiesConsentLabel'))));
    })));
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-awards/FooterAwards.jsx

var FooterAwards_jsx = react_default.a.createElement;




var FooterAwards_FooterAwards = function FooterAwards(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var track = Object(useTracking["a" /* useTracking */])();

  if (!items.length) {
    return null;
  }

  return FooterAwards_jsx("div", {
    className: classnames_default()(className, 'sm:py-30 sm:mb-30 border-0 sm:border-b sm:border-t sm:border-black')
  }, FooterAwards_jsx("ul", {
    className: "flex flex-wrap sm:flex-nowrap sm:gap-30"
  }, items.map(function (_ref2) {
    var label = _ref2.label,
        mediaUrl = _ref2.mediaUrl,
        url = _ref2.url;
    return FooterAwards_jsx("li", {
      className: "text-center w-1/2 sm:w-full flex justify-center pb-20 sm:pb-0",
      key: url
    }, FooterAwards_jsx("a", {
      className: "block max-w-[100px]",
      href: url,
      onClick: function onClick() {
        return track({
          actionGA: 'footer',
          labelGA: "award_".concat(label)
        });
      },
      rel: "noopener noreferrer",
      target: "_blank"
    }, FooterAwards_jsx(Image["a" /* Image */], {
      alt: label,
      className: "rounded-12 overflow-hidden",
      dimensions: {
        w: 200,
        h: 200
      },
      imageUrl: mediaUrl
    }), FooterAwards_jsx("p", {
      className: "text-black text-12 mt-10"
    }, label)));
  })));
};
// EXTERNAL MODULE: ./src/utils/tracking/footer.js
var tracking_footer = __webpack_require__("9sjr");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx + 1 modules
var BlockLink = __webpack_require__("Onl6");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-contacts/FooterContacts.jsx

var FooterContacts_jsx = react_default.a.createElement;




var CONTACT_TYPE_FAQ = 'faq';
var CONTACT_TYPE_MAIL = 'mail';
var CONTACT_TYPE_PHONE_BUBBLE = 'phoneBubble';
var CONTACT_TYPE_STORE_LOCATOR = 'storeLocator';
var getBlockDataTestId = function getBlockDataTestId(contactType) {
  switch (contactType) {
    case CONTACT_TYPE_PHONE_BUBBLE:
      return 'click-to-call';

    case CONTACT_TYPE_FAQ:
      return 'faq';

    case CONTACT_TYPE_MAIL:
      return 'newsletter';

    case CONTACT_TYPE_STORE_LOCATOR:
      return 'store-locator';

    default:
      return '';
  }
};
var getBlockTextsDataTestIds = function getBlockTextsDataTestIds(contactType) {
  switch (contactType) {
    case CONTACT_TYPE_PHONE_BUBBLE:
      return ['click-to-call-label', 'click-to-call-num', 'click-to-call-price'];

    case CONTACT_TYPE_FAQ:
    case CONTACT_TYPE_MAIL:
    case CONTACT_TYPE_STORE_LOCATOR:
    default:
      return [];
  }
};
var FooterContacts_FooterContacts = function FooterContacts(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return FooterContacts_jsx("div", {
    className: "lg:border-b-1 border-grey md:pb-20 pt-20 relative w-full z-1"
  }, FooterContacts_jsx("ul", {
    className: "divide-y md:divide-y-0 flex flex-col md:flex-row md:justify-between md:-mx-5"
  }, items.map(function (_ref2) {
    var href = _ref2.href,
        text = _ref2.text,
        type = _ref2.type;
    var texts = (text || []).map(function (txt) {
      // the phone number is always written in ltr, even in he-IL (which is rtl)
      return Object(RegexHelper["d" /* isPhoneNumber */])(txt) ? FooterContacts_jsx("span", {
        dir: "ltr"
      }, txt) : txt;
    });
    return FooterContacts_jsx("li", {
      className: "md:mx-5 py-10",
      "data-testid": getBlockDataTestId(type),
      key: type
    }, FooterContacts_jsx(BlockLink["a" /* BlockLink */], {
      className: "text-black",
      icon: type,
      target: "_blank",
      texts: texts,
      textsDataTestIds: getBlockTextsDataTestIds(type),
      trackingData: {
        actionGA: 'footer',
        labelGA: Object(tracking_footer["a" /* formatFooterLabelName */])(type)
      },
      url: href
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-policies/FooterPolicies.jsx

var FooterPolicies_jsx = react_default.a.createElement;



var FooterPolicies_FooterPolicies = function FooterPolicies(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return FooterPolicies_jsx("ul", {
    className: classnames_default()(className, 'text-12')
  }, items.map(function (_ref2) {
    var imageSrc = _ref2.imageSrc,
        label = _ref2.label,
        url = _ref2.url;
    return FooterPolicies_jsx("li", {
      className: "my-5",
      key: url
    }, FooterPolicies_jsx("a", {
      className: "gap-5 inline-flex items-center text-black hocus:text-black-active",
      href: url
    }, FooterPolicies_jsx(Image["b" /* default */], {
      className: "shrink-0",
      dontChangeAnything: true,
      imageUrl: imageSrc
    }), label));
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-seo/FooterSeo.jsx


var FooterSeo_jsx = react_default.a.createElement;


var FooterSeo_FooterSeo = function FooterSeo(_ref) {
  var className = _ref.className,
      description = _ref.description,
      title = _ref.title,
      siteplanLinkIsDisplayed = _ref.siteplanLinkIsDisplayed,
      siteplanLinkLabel = _ref.siteplanLinkLabel;

  if (!description && !title) {
    return null;
  }

  return FooterSeo_jsx("section", {
    className: className
  }, FooterSeo_jsx("p", {
    "aria-level": "2",
    className: "mb-10 text-12 uppercase",
    role: "heading"
  }, title), FooterSeo_jsx("p", {
    className: "mb-10 text-14"
  }, description), siteplanLinkIsDisplayed && FooterSeo_jsx("a", {
    className: "leading-1 text-inherit text-12 hocus:text-black-active transition-color",
    href: routes_constants["G" /* SITEPLAN_PAGE_URL */]
  }, siteplanLinkLabel));
};
// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-social-networks/FooterSocialNetworks.jsx

var FooterSocialNetworks_jsx = react_default.a.createElement;



var FooterSocialNetworks_FooterSocialNetworks = function FooterSocialNetworks(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return FooterSocialNetworks_jsx("div", {
    className: "decoration-strikethrough lg:ps-10 relative w-full lg:w-auto z-1"
  }, FooterSocialNetworks_jsx("ul", {
    className: "flex md:justify-center lg:justify-start -mx-5 py-20 md:py-0"
  }, items.map(function (_ref2) {
    var icon = _ref2.icon,
        href = _ref2.href,
        label = _ref2.label;
    return FooterSocialNetworks_jsx("li", {
      className: "mx-5",
      key: href
    }, FooterSocialNetworks_jsx(TrackClick["a" /* TrackClick */], {
      as: "a",
      className: "bg-lightSand border-1 border-grey flex items-center justify-center overflow-hidden rounded-12 text-center text-black hocus:text-black-active",
      href: href,
      rel: "noopener noreferrer",
      style: {
        width: '3.125rem',
        height: '3.125rem'
      },
      target: "_blank",
      trackingData: {
        actionGA: 'footer',
        labelGA: icon
      }
    }, FooterSocialNetworks_jsx(Icon["a" /* Icon */], {
      alt: typeof icon === 'string' ? icon : '',
      name: icon,
      width: "1.5rem"
    }), FooterSocialNetworks_jsx("span", {
      className: "sr-only"
    }, "Club Med - ".concat(label))));
  })));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-tripadvisor/FooterTripAdvisor.jsx
var FooterTripAdvisor_jsx = react_default.a.createElement;



var FooterTripAdvisor_FooterTripAdvisor = function FooterTripAdvisor(_ref) {
  var className = _ref.className,
      text = _ref.text;

  if (!text) {
    return null;
  }

  return FooterTripAdvisor_jsx("div", {
    className: classnames_default()(className, 'text-end')
  }, FooterTripAdvisor_jsx("span", {
    className: "align-middle text-10 sm:text-14",
    "data-testid": "FooterTripAdvisor-title"
  }, text), FooterTripAdvisor_jsx("span", {
    className: "align-middle inline-block ms-10"
  }, FooterTripAdvisor_jsx(Image["b" /* default */], {
    altMsg: "Trip Advisor",
    dontChangeAnything: true,
    imageUrl: "https://tripadvisor.mediaroom.com/images/Tripadvisor_lockup_horizontal_registered.png",
    style: {
      width: '8.5rem'
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-websites/footer-website/FooterWebsite.jsx


var FooterWebsite_jsx = react_default.a.createElement;


var FooterWebsite_FooterWebsite = function FooterWebsite(_ref) {
  var description = _ref.description,
      href = _ref.href,
      iconAlt = _ref.iconAlt,
      iconName = _ref.iconName,
      iconWidth = _ref.iconWidth,
      isVisible = _ref.isVisible;

  if (!isVisible) {
    return null;
  }

  return FooterWebsite_jsx("li", {
    className: "align-top inline-block mb-40 px-10 w-1/2 lg:w-full"
  }, FooterWebsite_jsx("a", {
    className: "block hocus:underline",
    rel: "noopener noreferrer",
    target: "_blank",
    href: href
  }, FooterWebsite_jsx("p", {
    "aria-level": "2",
    className: "mb-5",
    role: "heading",
    style: {
      minHeight: '2.5rem'
    }
  }, FooterWebsite_jsx(Icon["a" /* Icon */], {
    alt: iconAlt,
    name: iconName,
    isNotSquare: true,
    width: iconWidth
  }), FooterWebsite_jsx("span", {
    className: "sr-only"
  }, iconAlt)), FooterWebsite_jsx("p", {
    className: "text-14"
  }, description)));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-websites/FooterWebsites.jsx

var FooterWebsites_jsx = react_default.a.createElement;



var FooterWebsites_FooterWebsites = function FooterWebsites(_ref) {
  var business = _ref.business,
      className = _ref.className,
      corp = _ref.corp,
      job = _ref.job,
      property = _ref.property;
  return FooterWebsites_jsx("div", {
    className: className
  }, FooterWebsites_jsx("ul", {
    className: "-mx-10"
  }, FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, business, {
    iconAlt: "Meetings and events by Club Med",
    iconName: icons["a" /* ICONS */].CLUBMED_MEETINGS,
    iconWidth: "12.5rem"
  })), FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, property, {
    iconAlt: "Club Med Property",
    iconName: icons["a" /* ICONS */].CLUBMED_PROPERTY,
    iconWidth: "7.5rem"
  })), FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, job, {
    iconAlt: "ClubMed Jobs",
    iconName: icons["a" /* ICONS */].CLUBMED_JOBS,
    iconWidth: "7.5rem"
  })), FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, corp, {
    iconAlt: "Club M\xE9diterran\xE9e",
    iconName: icons["a" /* ICONS */].CLUBMED,
    iconWidth: "7.5rem"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/Footer.jsx

var Footer_jsx = react_default.a.createElement;















var Footer_Footer = function Footer(_ref) {
  var annexes = _ref.annexes,
      awards = _ref.awards,
      contacts = _ref.contacts,
      className = _ref.className,
      policies = _ref.policies,
      socialNetworks = _ref.socialNetworks,
      seo = _ref.seo,
      tabText = _ref.tabText,
      tripAdvisor = _ref.tripAdvisor,
      websites = _ref.websites;
  var track = Object(useTracking["a" /* useTracking */])();

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var openDidomiPreferences = function openDidomiPreferences(e) {
    var _window$Didomi;

    e.preventDefault();
    (_window$Didomi = window.Didomi) === null || _window$Didomi === void 0 ? void 0 : _window$Didomi.preferences.show();
    track({
      categoryGA: pageType,
      labelGA: 'cookiesManagement',
      actionGA: 'footer'
    });
  };

  return Footer_jsx("footer", {
    className: classnames_default()(className, 'relative z-3'),
    "data-testid": "Footer",
    role: "contentinfo"
  }, Footer_jsx("div", {
    className: "text-16 text-black"
  }, Footer_jsx("div", {
    className: "m-auto w-full max-w-site"
  }, Footer_jsx("div", {
    className: "bg-lightSand font-bold inline-block px-10 relative text-16 text-lightSand",
    style: {
      bottom: '-1px',
      height: '2.5rem',
      left: '1.5rem',
      lineHeight: '2.5rem',
      right: '1.5rem'
    }
  }, Footer_jsx("svg", {
    className: "absolute fill-current top-0",
    width: "24",
    height: "40",
    viewBox: "0 0 24 40",
    style: {
      height: '2.5rem',
      left: -23
    }
  }, Footer_jsx("path", {
    d: "M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z"
  })), Footer_jsx("svg", {
    className: "absolute fill-current top-0 transform -scale-x-1",
    width: "24",
    height: "40",
    viewBox: "0 0 24 40",
    style: {
      height: '2.5rem',
      right: -23
    }
  }, Footer_jsx("path", {
    d: "M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z"
  })), Footer_jsx("span", {
    className: "text-black"
  }, tabText))), Footer_jsx("div", {
    className: "bg-lightSand flex items-center px-20"
  }, Footer_jsx("div", {
    className: "flex flex-col lg:flex-row md:items-end m-auto max-w-site relative w-full"
  }, Footer_jsx(FooterContacts_FooterContacts, {
    items: contacts
  }), Footer_jsx(FooterSocialNetworks_FooterSocialNetworks, {
    items: socialNetworks
  }), Footer_jsx(FooterAwards_FooterAwards, {
    items: awards,
    className: "block sm:hidden"
  })))), Footer_jsx("div", {
    className: "bg-lightSand text-black px-20"
  }, Footer_jsx("div", {
    className: "flex flex-wrap m-auto max-w-site py-20"
  }, Footer_jsx(FooterWebsites_FooterWebsites, Object(esm_extends["a" /* default */])({}, websites, {
    className: "hidden sm:block lg:w-2/5 lg:pe-95"
  })), Footer_jsx("div", {
    className: "lg:w-3/5"
  }, Footer_jsx(FooterAnnexes_FooterAnnexes, {
    items: annexes,
    className: "hidden sm:block",
    openDidomiPreferences: openDidomiPreferences
  }), Footer_jsx(FooterAwards_FooterAwards, {
    items: awards,
    className: "hidden sm:block"
  }), Footer_jsx(FooterSeo_FooterSeo, Object(esm_extends["a" /* default */])({}, seo, {
    className: "md:w-4/5 lg:w-auto"
  })), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('displayFooterPolicies') && Footer_jsx(FooterPolicies_FooterPolicies, {
    items: policies,
    className: "mt-30"
  }), Footer_jsx("div", {
    className: "md:hidden mt-30"
  }, Footer_jsx("div", {
    className: "mb-10 font-sans font-bold text-12"
  }, Object(i18n["h" /* t */])('footer.legalInformations.title')), Footer_jsx("button", {
    className: "text-12 text-black underline",
    onClick: openDidomiPreferences,
    type: "button"
  }, Object(i18n["h" /* t */])('footer.legalInformations.cookiesConsentLabel')))), Footer_jsx(FooterTripAdvisor_FooterTripAdvisor, Object(esm_extends["a" /* default */])({}, tripAdvisor, {
    className: "mt-20 pt-20 w-full"
  })))));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/FooterContainer.jsx
















var FooterContainer_jsx = react_default.a.createElement;

function FooterContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FooterContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FooterContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FooterContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















function FooterContainer(_ref) {
  var newsletters = _ref.newsletters,
      legalInformations = _ref.legalInformations,
      _ref$config = _ref.config,
      common = _ref$config.common,
      _ref$config$cookieWar = _ref$config.cookieWarning,
      approve = _ref$config$cookieWar.approve,
      cookieLabel = _ref$config$cookieWar.label,
      layer = _ref$config$cookieWar.layer,
      otherCookieWarningProps = Object(objectWithoutProperties["a" /* default */])(_ref$config$cookieWar, ["approve", "label", "layer"]),
      newsletter = _ref$config.newsletter,
      footer = _ref$config.footer,
      webCallback = _ref$config.webCallback,
      viewedPageCount = _ref.viewedPageCount;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var router = Object(next_router["useRouter"])();

  var _useState = Object(react["useState"])(false),
      hasExitIntend = _useState[0],
      setHasExitIntend = _useState[1];

  var isExitIntendEnabled = Object(i18n["d" /* getKeyValue */])('newsletter.popin.exitIntent');
  var isNewsletterPopinAllowedOnCurrentPage = !['/account', '/booking/', '/newsletter'].includes(new URI_default.a(router.asPath).pathname());
  var hasViewedNewsletterPopin = Object(local_storage_api["a" /* getFromLocalStorage */])(PopinNewsletter["b" /* POPIN_NEWSLETTER */]) === 'viewed';
  var mayDisplayNewsletterPopin = !hasViewedNewsletterPopin && !appContext.isUserLogged && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('displayNewsletterPopin') && Object(analyticsUtils["a" /* isAnalyticsEnabled */])();
  var pagesViewed = Object(i18n["d" /* getKeyValue */])('newsletter.popin.pagesViewed');

  var removeExitIntendListener = function removeExitIntendListener() {
    document.removeEventListener('mouseout', exitIntend);
  };

  var exitIntend = function exitIntend(e) {
    if (isNewsletterPopinAllowedOnCurrentPage && !e.toElement && !e.relatedTarget && e.clientY < 50) {
      removeExitIntendListener();
      setHasExitIntend(true);
    }
  };

  Object(react["useEffect"])(function () {
    if (isExitIntendEnabled && mayDisplayNewsletterPopin) {
      document.addEventListener('mouseout', exitIntend);
    }

    return function () {
      removeExitIntendListener();
    };
  }, [isExitIntendEnabled && mayDisplayNewsletterPopin && isDesktop]);
  var enableNewsletterPopin = mayDisplayNewsletterPopin && isNewsletterPopinAllowedOnCurrentPage && viewedPageCount > pagesViewed;

  if (isDesktop) {
    enableNewsletterPopin = enableNewsletterPopin && hasExitIntend;
  }

  var isCookiesBannerEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('cookiesBanner.isEnabled');
  Object(i18n["a" /* addTranslationKeys */])({
    common: common,
    webCallback: FooterContainer_objectSpread(FooterContainer_objectSpread({}, webCallback), common.dateTime),
    newsletter: newsletter
  }); // $FlowFixMe mixed footer link types

  var mapLink = function mapLink(_ref2) {
    var href = _ref2.href,
        url = _ref2.url,
        link = Object(objectWithoutProperties["a" /* default */])(_ref2, ["href", "url"]);

    return FooterContainer_objectSpread(FooterContainer_objectSpread(FooterContainer_objectSpread({}, link), href != null && {
      href: Object(uriUtils["e" /* formatLink */])(href, appContext.originalUrl, router.query.locale, pageType, link.type)
    }), url != null && {
      url: Object(uriUtils["e" /* formatLink */])(url, appContext.originalUrl, router.query.locale, pageType, link.type)
    });
  };

  var mapLinks = function mapLinks(_ref3) {
    var links = _ref3.links,
        rest = Object(objectWithoutProperties["a" /* default */])(_ref3, ["links"]);

    return FooterContainer_objectSpread(FooterContainer_objectSpread({}, rest), {}, {
      links: links.map(mapLink)
    });
  };

  var footerProps = Object(react["useMemo"])(function () {
    return {
      annexes: footer.annexes.map(mapLinks),
      awards: footer.awards.map(mapLink),
      contacts: footer.contactsBar.map(mapLink),
      socialNetworks: footer.socialNetworks.map(mapLink),
      websites: Object.fromEntries(Object.entries(footer.websites).map(function (_ref4) {
        var _ref5 = Object(slicedToArray["a" /* default */])(_ref4, 2),
            label = _ref5[0],
            link = _ref5[1];

        return [label, mapLink(link)];
      }))
    };
  }, [footer]);
  var policies = Object(react["useMemo"])(function () {
    if (appContext.locale !== locale_constants["a" /* LOCALES */].ZH_CN) {
      return [];
    }

    return [{
      imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov1.png',
      label: '沪公网安备31010102005123号',
      url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005123'
    }, {
      imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov2.png',
      label: '上海工商',
      url: 'http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&entyId=gs20140504000004692'
    }, {
      imageSrc: 'https://ns.clubmed.com/grc/2021/66/B2C/B2C-common/lz2small.png',
      label: '电子营业执照',
      url: 'http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020180720162942000002716445-SAIC_SHOW_310000-gs20140504000004692831&signData=MEQCICVEte6pmi5SO//8AxfjZUK7RxW7WeW24X4RCCfMtOz/AiBvLE0C/bmZf+2F8yZFnspaSbC5Xu6wxR0IAvym4a0VEg=='
    }];
  }, [appContext.locale]);

  var _useState2 = Object(react["useState"])(enableNewsletterPopin),
      showNewsletterPopin = _useState2[0],
      setPopinShow = _useState2[1];

  Object(react["useEffect"])(function () {
    return setPopinShow(enableNewsletterPopin);
  }, [enableNewsletterPopin]);
  var onClosePopin = Object(react["useCallback"])(function () {
    setPopinShow(false);
    Object(local_storage_api["c" /* setInLocalStorage */])(PopinNewsletter["b" /* POPIN_NEWSLETTER */], 'viewed');
  }, []);
  return FooterContainer_jsx(react["Fragment"], null, showNewsletterPopin && FooterContainer_jsx(PopinNewsletter["c" /* PopinNewsletter */], {
    checkboxes: newsletters,
    legalInformations: legalInformations ? legalInformations.newsletter : [],
    onClose: onClosePopin
  }), isCookiesBannerEnabled && FooterContainer_jsx(CookieWarning, Object(esm_extends["a" /* default */])({}, otherCookieWarningProps, {
    buttonLabel: approve,
    closeLabel: common.close,
    layerInfo: layer,
    text: cookieLabel,
    isAppMounted: isAppMounted,
    isApproved: !!js_cookie_default.a.get(constants["g" /* COOKIE_WARNING_LOCALSTORAGE_KEY */])
  })), FooterContainer_jsx(Footer_Footer, Object(esm_extends["a" /* default */])({}, footerProps, {
    policies: policies,
    seo: footer.seo,
    tabText: footer.contactsBarLabel,
    tripAdvisor: footer.tripAdvisor
  })));
}

/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BlockLink_BlockLink; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex gap-5 items-center font-bold font-sans leading-1 no-underline text-12',
    thIconWidth: '2.5rem',
    thSText: 'text-14 uppercase',
    thCustomText1: 'text-14 uppercase'
  },
  black: {
    thRoot: 'flex gap-5 sm:gap-10 justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-black text-16',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row gap_10 items-center text-center lg:text-initial text-black',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-black text-14',
    thCustomText0: 'font-bold text-16',
    thCustomText1: 'font-bold text-16'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx













var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var DEFAULT_DATA_TEST_ID = 'BlockLink-text';
var BlockLink_BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(classCallCheck["a" /* default */])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts(_ref) {
      var _ref$classes = _ref.classes,
          classes = _ref$classes === void 0 ? '' : _ref$classes,
          _ref$texts = _ref.texts,
          texts = _ref$texts === void 0 ? [] : _ref$texts,
          _ref$textsDataTestIds = _ref.textsDataTestIds,
          textsDataTestIds = _ref$textsDataTestIds === void 0 ? [] : _ref$textsDataTestIds;
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme;
      return texts.filter(function (text) {
        return !isEmpty_default()(text);
      }).map(function (text, idx) {
        var dataTestId = idx < textsDataTestIds.length ? textsDataTestIds[idx] : DEFAULT_DATA_TEST_ID;
        return __jsx("span", {
          className: classnames_default()(classes, 'block', themes[theme]["thCustomText".concat(idx)]),
          "data-testid": dataTestId,
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          icon = _this$props.icon,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          _this$props$secondary = _this$props.secondaryTexts,
          secondaryTexts = _this$props$secondary === void 0 ? [] : _this$props$secondary,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? '_blank' : _this$props$target,
          _this$props$texts = _this$props.texts,
          texts = _this$props$texts === void 0 ? [] : _this$props$texts,
          _this$props$textsData = _this$props.textsDataTestIds,
          textsDataTestIds = _this$props$textsData === void 0 ? [] : _this$props$textsData,
          _this$props$theme2 = _this$props.theme,
          theme = _this$props$theme2 === void 0 ? 'default' : _this$props$theme2,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = themes[theme],
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thTexts = _themes$theme.thTexts,
          thSText = _themes$theme.thSText;
      return !!texts.length || icon ? __jsx(TrackClick["a" /* TrackClick */], {
        as: "a",
        className: classnames_default()(className, thRoot),
        "data-testid": dataTestId,
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(Icon["a" /* Icon */], {
        className: "shrink-0",
        name: icon,
        width: thIconWidth
      }), !!texts.length && __jsx("span", {
        className: thTexts
      }, this.renderTexts({
        texts: texts,
        textsDataTestIds: textsDataTestIds
      }), this.renderTexts({
        classes: thSText,
        texts: secondaryTexts
      }))) : null;
    }
  }]);

  return BlockLink;
}(react["PureComponent"]);

/***/ }),

/***/ "U2fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAYER_HEADER_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Layer; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Bcqe");
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_focus_on__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Qt1m");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("UCZK");
/* harmony import */ var _context_ToastContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("waz2");
/* harmony import */ var _body_locker_BodyLocker__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("DHMe");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("3uBn");
/* harmony import */ var _layer_header_LayerHeader__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("csq+");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;









var LAYER_HEADER_HEIGHT = 60;

var onScroll = lodash_throttle__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  Object(react_lazyload__WEBPACK_IMPORTED_MODULE_9__["forceCheck"])();
}, 250);

var LayerComponent = function LayerComponent(_ref, layerRef) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_11__[/* COLORS */ "a"].WHITE : _ref$bgColor,
      buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      customHeader = _ref.customHeader,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Layer' : _ref$dataTestId,
      _ref$enterAnimation = _ref.enterAnimation,
      enterAnimation = _ref$enterAnimation === void 0 ? 'slideInRight' : _ref$enterAnimation,
      _ref$externalFocusTra = _ref.externalFocusTrapRefs,
      externalFocusTrapRefs = _ref$externalFocusTra === void 0 ? [] : _ref$externalFocusTra,
      _ref$fixLayerHeight = _ref.fixLayerHeight,
      fixLayerHeight = _ref$fixLayerHeight === void 0 ? false : _ref$fixLayerHeight,
      hasAnimateEnter = _ref.hasAnimateEnter,
      hasContainer = _ref.hasContainer,
      hasContainerHeader = _ref.hasContainerHeader,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      header = _ref.header,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_7__["useContext"])(_context_ToastContext__WEBPACK_IMPORTED_MODULE_12__[/* ToastContext */ "a"]),
      ref = _useContext.ref;

  var layerBody = Object(react__WEBPACK_IMPORTED_MODULE_7__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_7__["useImperativeHandle"])(layerRef, function () {
    return layerBody.current;
  }, [layerBody]);
  Object(react__WEBPACK_IMPORTED_MODULE_7__["useEffect"])(function () {
    var _layerBody$current;

    (_layerBody$current = layerBody.current) === null || _layerBody$current === void 0 ? void 0 : _layerBody$current.addEventListener('scroll', onScroll);
    return function () {
      var _layerBody$current2;

      (_layerBody$current2 = layerBody.current) === null || _layerBody$current2 === void 0 ? void 0 : _layerBody$current2.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!react__WEBPACK_IMPORTED_MODULE_7__["Children"].count(children)) {
    return null;
  }

  var hasHeader = buttonLeft || buttonRight || header;

  var getStyle = function getStyle() {
    return hasHeader || !hasHeader && customHeader ? {
      paddingTop: customHeader ? customHeader.height : LAYER_HEADER_HEIGHT
    } : {};
  };

  var shards = ref ? [ref].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(externalFocusTrapRefs)) : externalFocusTrapRefs;
  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"], {
    name: portalName
  }, __jsx(react_focus_on__WEBPACK_IMPORTED_MODULE_10__[/* FocusOn */ "a"], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: shards.filter(Boolean)
  }, __jsx(_body_locker_BodyLocker__WEBPACK_IMPORTED_MODULE_13__[/* BodyLocker */ "a"], {
    isLocked: true
  }, __jsx("aside", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()(className, "bg-".concat(bgColor), 'fixed inset-0 w-full escape-responsive-helper', Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])({}, enterAnimation, hasAnimateEnter)),
    "data-testid": dataTestId,
    role: "document"
  }, hasHeader && __jsx(_layer_header_LayerHeader__WEBPACK_IMPORTED_MODULE_15__[/* LayerHeader */ "a"], {
    buttonLeft: buttonLeft,
    buttonRight: buttonRight,
    closeLabel: [closeLabel, ariaLabel].join(' ').trim(),
    hasContainer: hasContainerHeader,
    height: LAYER_HEADER_HEIGHT,
    onClose: onClose,
    theme: theme
  }, header), !hasHeader && customHeader && customHeader.content, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()('h-full scroll-y duration-250 ease-in transition-all z-0', {
      'px-20': hasContainer
    }),
    "data-testid": "Layer-body",
    ref: layerBody,
    style: getStyle()
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()({
      'h-full': !fixLayerHeight,
      'min-h-full': true,
      'mx-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "Layer-content"
  }, children)))))));
}; // $FlowFixMe


var Layer = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_7__["forwardRef"])(LayerComponent);

/***/ }),

/***/ "csq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LayerHeader_LayerHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.themes.js
var themes = function themes(_ref) {
  var isActive = _ref.isActive,
      hasIcon = _ref.hasIcon;
  return {
    "default": {
      thRoot: "cursor-pointer flex flex-col sm:flex-row items-center p-5 rounded-5 text-12 text-black transition-colors duration-250 ease-in".concat(isActive ? ' bg-saffron hocus:bg-saffron-active' : ' hocus:text-black-active'),
      thIcon: 'm-5 shrink-0',
      thIconWidth: '1.25rem',
      thLabel: hasIcon ? 'sr-only' : ''
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.jsx

var __jsx = react_default.a.createElement;




var LayerHeaderButton_LayerHeaderButton = function LayerHeaderButton(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconClassName = _ref.iconClassName,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      label = _ref.label,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!label && !iconName) {
    return null;
  }

  var hasIcon = !!iconName;
  var _themes$theme = themes({
    isActive: isActive,
    hasIcon: hasIcon
  })[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("button", Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId,
    onClick: onClick
  }, tabIndex === -1 ? {
    tabIndex: tabIndex
  } : null, {
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thIcon, iconClassName),
    hasRtl: true,
    name: iconName,
    width: thIconWidth
  }), !!label && __jsx("span", {
    className: thLabel
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.themes.js
var LayerHeader_themes_themes = {
  "default": {
    thRoot: 'bg-white fixed overflow-hidden px-20 shadow-diffuse transition-heights duration-250 ease-in w-full z-3',
    thInner: 'flex h-full items-center w-full',
    thChild: 'w-full',
    thClose: 'leading-0 ms-auto order-1 p-10 text-black hocus:text-black-active transition-color',
    thCloseIconWidth: '1rem',
    thCloseLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.jsx

var LayerHeader_jsx = react_default.a.createElement;






var LayerHeader_LayerHeader = function LayerHeader(_ref) {
  var buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasContainer = _ref.hasContainer,
      height = _ref.height,
      onClose = _ref.onClose,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var layerButtonRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);
  var _themes$theme = LayerHeader_themes_themes[theme],
      thChild = _themes$theme.thChild,
      thClose = _themes$theme.thClose,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thCloseLabel = _themes$theme.thCloseLabel,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  return LayerHeader_jsx("header", {
    className: classnames_default()(className, thRoot),
    style: {
      height: height,
      maxHeight: height
    }
  }, LayerHeader_jsx("div", {
    className: classnames_default()(thInner, {
      'm-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "LayerHeader-body"
  }, LayerHeader_jsx("button", {
    className: thClose,
    "data-testid": "Layer-close",
    onClick: onClose,
    ref: layerButtonRef,
    type: "button"
  }, !!closeLabel && LayerHeader_jsx("span", {
    className: thCloseLabel
  }, closeLabel), LayerHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-left"
  }, buttonLeft, {
    theme: theme
  })), !!react["Children"].count(children) && LayerHeader_jsx("div", {
    className: thChild
  }, children), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-right"
  }, buttonRight, {
    theme: theme
  }))));
};

/***/ })

}]);